import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import { ChatBot } from "@/components/chat/ChatBot";
import { GlobalSearch } from "@/components/search/GlobalSearch";
import { AIStatusBanner } from "@/components/AIStatusBanner";
import { Switch } from "@/components/ui/switch";
import { useSettings } from "@/providers/SettingsProvider";
import { Sun, Moon } from "lucide-react";
import LanguageSelector from "./LanguageSelector";

export const Layout = () => {
	const settings = useSettings();
	const isDarkMode = settings.colorMode === "dark";
	
	const toggleDarkMode = () => {
		settings.setColorModeValue(isDarkMode ? "light" : "dark");
		document.documentElement.classList.toggle("dark");
	};
	
	return (
		<div className="flex h-screen overflow-hidden">
			<Sidebar />
			<div className="flex-1 flex flex-col overflow-hidden bg-gradient-to-br from-background/80 to-background transition-colors duration-300">
				<header className="border-b border-white/20 dark:border-white/10 p-4 bg-white/60 dark:bg-black/40 backdrop-blur-md sticky top-0 z-10">
					<div className="max-w-6xl mx-auto w-full flex items-center justify-between">
						<GlobalSearch />
						<div className="flex items-center gap-4">
							<LanguageSelector />
							<div className="flex items-center gap-2">
								<Sun className="h-4 w-4 text-foreground/70" />
								<Switch checked={isDarkMode} onCheckedChange={toggleDarkMode} />
								<Moon className="h-4 w-4 text-foreground/70" />
							</div>
						</div>
					</div>
				</header>
				<main className="flex-1 overflow-y-auto overflow-x-hidden p-4 md:p-6">
					<AIStatusBanner />
					<div className="w-full max-w-full mx-auto animate-fade-in">
						<Outlet />
					</div>
				</main>
			</div>
			<ChatBot />
		</div>
	);
};
